import {
  ManageOwnershipDialog,
  entityToOwnershipEntity,
  useManageOwnershipDialog,
} from '@internal/backstage-plugin-common-library-react';
import React from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  button: {
    textTransform: 'none',
  },
}));

export const PagerDutyTeamManageOwnership = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const { dialogOpen, openDialog, closeDialog, handleSuccess } =
    useManageOwnershipDialog({ dialogTarget: 'pagerduty-team' });

  return (
    <>
      <Button
        className={classes.button}
        color="primary"
        variant="outlined"
        onClick={openDialog}
      >
        Manage Ownership
      </Button>

      <ManageOwnershipDialog
        open={dialogOpen}
        entities={[
          { ...entityToOwnershipEntity(entity), kind: 'pagerduty-team' },
        ]}
        onClose={closeDialog}
        onSuccess={handleSuccess}
      />
    </>
  );
};
